import { formatCompactMoney } from 'Helpers/formatService';

/**
 * Prefix a compact money figure with the budget's currency symbol.
 * The Overview renders headline figures compactly (e.g. "€35.8M").
 */
export const money = (symbol, val) => `${symbol ?? ''}${formatCompactMoney(val ?? 0)}`;

/**
 * Per-stage presentation for the 7-stage pipeline board, keyed by the stage's index
 * in ProcurementStatus::TITLES (Not Started → Complete). Dots and fill bars progress
 * grey → blue (pre-award) → green (awarded/in progress) → black (complete), matching the
 * IB-699 mockup. All colours come from tailwind.config.js.
 */
export const PIPELINE_STAGE_STYLES = [
    { dot: 'tw-bg-charcoal-25', bar: 'tw-bg-charcoal-25' }, // Not Started
    { dot: 'tw-bg-blue-50', bar: 'tw-bg-blue-50' }, // PR Submitted
    { dot: 'tw-bg-blue', bar: 'tw-bg-blue' }, // RFP Issued
    { dot: 'tw-bg-blue', bar: 'tw-bg-blue' }, // Tender Evaluation
    { dot: 'tw-bg-green', bar: 'tw-bg-green' }, // Awarded
    { dot: 'tw-bg-green', bar: 'tw-bg-green' }, // In Progress
    { dot: 'tw-bg-black', bar: 'tw-bg-black' }, // Complete
];

export const stageStyleFor = (index) => PIPELINE_STAGE_STYLES[index] ?? PIPELINE_STAGE_STYLES[0];

/**
 * Coverage segment colours (shared by the coverage bar and coverage-by-department bars).
 * The three segments — committed / in-plan / still-to-be-planned — sum to the procurable budget.
 */
export const COVERAGE_COLOURS = {
    committed: 'tw-bg-green',
    inPlan: 'tw-bg-blue',
    stillToPlan: 'tw-bg-charcoal-25',
};
